import { useEffect, useState } from "react";
import { Doughnut } from "react-chartjs-2";
import { useTheme } from "../context/ThemeContext";
import { Chart as ChartJS, ArcElement, Tooltip } from "chart.js";

ChartJS.register(ArcElement, Tooltip);

export default function SimpleDoughnutChart({ data, colors = [], legend, total, totalValue }) {
    const [chartData, setChartData] = useState(null);
    const { theme } = useTheme();

    useEffect(() => {
        if (
            !Array.isArray(data) ||
            data.length === 0 ||
            typeof data[0] !== "object" ||
            data[0] === null
        ) {
            return;
        }

        const dataObj = data[0];
        const labels = Object.keys(dataObj);
        const values = Object.values(dataObj);

        const bgColors = colors.length >= labels.length
            ? colors
            : ["#FF6384", "#36A2EB", "#FFCE56", "#4BC0C0"].slice(0, labels.length);

        setChartData({
            labels,
            datasets: [
                {
                    data: values,
                    backgroundColor: bgColors,
                    borderWidth: 0,
                },
            ],
        });
    }, [data, colors]);

    if (!chartData) {
        return null;
    }

    const options = {
        responsive: true,
        maintainAspectRatio: false,
        cutout: '65%',
        plugins: {
            tooltip: {
                enabled: !total,
                callbacks: {
                    label: ({ label, raw }) => `${label}: ${raw}`,
                },
            },
            legend: { display: false },
        },
    };

    // Plugin pour afficher le total au centre
    const centerTextPlugin = {
        id: 'centerText',
        beforeDraw: (chart) => {
            if (total) {
                const ctx = chart.ctx;
                const centerX = (chart.chartArea.left + chart.chartArea.right) / 2;
                const centerY = (chart.chartArea.top + chart.chartArea.bottom) / 2;

                ctx.save();
                ctx.font = '12px Inter';
                ctx.textAlign = 'center';
                ctx.textBaseline = 'middle';
                const textColor = theme === "dark" ? '#ffffff' : '#11263c'; 
                ctx.fillStyle = textColor;
                ctx.fillText(`${totalValue}`, centerX, centerY);
                ctx.restore();
            }
        }
    };

    const plugins = total ? [centerTextPlugin] : [];

    return (
        <>
            <div className="dashboard-graph-doughnut-simple">
                <Doughnut data={chartData} options={options} plugins={plugins} />
            </div>
            {legend && (
                <ul>
                    {chartData.labels.map((label, index) => (
                        <li key={index}>
                            <p className="dashboard-graph-doughnut-simple-content">
                                <span
                                    className="dashboard-graph-doughnut-simple-content-color"
                                    style={{
                                        backgroundColor: chartData.datasets[0].backgroundColor[index],
                                    }}
                                ></span>
                                <span className="dashboard-graph-doughnut-simple-content-legend">
                                    <span>
                                        {chartData.datasets[0].data[index]}
                                    </span>
                                    {label}
                                </span>
                            </p>
                        </li>
                    ))}
                </ul>
            )}
        </>
    );
}